// ⚠️ AUTOMATICALLY GENERATED - DO NOT CHANGE
const CHANNEL = '59317780';
export const MAIN = '=' + CHANNEL;
export const WORKER = '-' + CHANNEL;
